/**
 * The current Darkwing branch, if any
 */
export const branch = /darkwing_subdomain=(.+?)(;|$)/.exec(window.document.cookie)?.[1];

/**
 * If running a branch, clears the branch cookie and reloads the page.
 */
export function clearBranch() {
  if (!branch) return;
  const domain = /([^\.]+\.[^\.]+?)$/.exec(window.location.hostname)?.[1];

  document.cookie = `darkwing_subdomain=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=.${domain}`;
  window.location.reload();
}
